<template>
  <div :class="['advanced-domain-select', className, `size-${size}`]" >
    <span class="advanced-domain-select__title" v-if="title">{{ title }}</span>
    <v-select
      v-model="value"
      :items="items"
      :size="size"
      append-icon="expand_more"
      dense
      outlined
      multiple
      full-width
      height="40"
      :placeholder="value.length > 0 ? '' : $t('advanced.domain.select.do.select')"
    >
      <template v-slot:selection="{ index }">
        <div v-if="selectAll && index === 0">
          <span v-if="value.length === 1" class="selection-text">{{ value[0] }}</span>
          <span v-else class="selection-text">{{ $t('advanced.domain.select.selection.all') }}</span>
        </div>
        <div v-else-if="selectSome && index === 0">
          <span v-if="value.length === 1" class="selection-text">{{ value[0] }}</span>
          <span v-else class="selection-text">{{ $t('advanced.domain.select.selection.selected') }} {{ value.length }} {{ $t('advanced.domain.select.selection.domains') }}</span>
        </div>
      </template>
      <template v-slot:prepend-item>
        <v-list-item
          ripple
          @click="toggle"
        >
          <v-list-item-action>
            <v-icon class="material-icons-outlined" :color="value.length > 0 ? 'cyan darken-4' : ''">
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('advanced.domain.select.all') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:item="data">
        <v-list-item
          ripple
          @click="toggleSingle(data.item, true)"
        >
          <v-list-item-action>
            <v-checkbox
              v-model="value"
              :value="data.item"
              @click="checkboxClick"
            >
            </v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <div>
              <v-icon> language </v-icon>
              {{ data.item }}
            </div>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:append-item>
        <v-divider class="mb-2"></v-divider>
        <v-list-item disabled>
          <v-list-item-avatar color="grey lighten-3">
            <v-icon>
              domain
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content v-if="selectAll">
            <v-list-item-title>
              {{ $t('advanced.domain.select.all.selected') }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-content v-else-if="selectSome">
            <v-list-item-title>
              {{ $t('advanced.domain.select.total') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ value.length }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-content v-else>
            <v-list-item-title>
              {{ $t('advanced.domain.select.no.selected') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('advanced.domain.select.do.select') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'AdvancedResourceSelect',
  props: {
    className: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    size: {
      type: String,
      default: () => '',
    },
    items: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectAll() {
      return this.value.length === this.items.length;
    },
    selectSome() {
      return this.value.length > 0 && !this.selectAll;
    },
    selectNone() {
      return this.value.length <= 0 && !this.selectAll;
    },
    icon() {
      if (this.selectAll) return 'disabled_by_default';
      if (this.selectSome) return 'indeterminate_check_box';
      return 'check_box_outline_blank';
    },
  },
  methods: {
    toggle() {
      if (this.selectAll) {
        this.value = [];
      } else {
        this.value = this.items.slice();
      }
      this.$emit('input', this.value);
    },
    toggleSingle(item) {
      if (this.value.includes(item)) {
        this.value.splice(this.value.indexOf(item), 1);
      } else {
        this.value.push(item);
      }
      this.$emit('input', this.value);
    },
    checkboxClick() {
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.resources-select {
  width: rem(532);
  background-color: var(--bg-secondary);
}

.advanced-domain-select {
  .v-input {
    margin-top: 0;
  }

  &__title {
    font-family: $font-family-regular;
    font-size: $font-size-xs;
    letter-spacing: 0.8px;
    line-height: $font-size-xs;
    margin-bottom: $space-1;
    color: var(--text-secondary);
  }
}

.selection-text {
  color: var(--text-primary);
  font-family: $font-family-regular;
  font-size: $font-size-base;
}

.v-menu__content {
  min-width: rem(532);
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.advanced-domain-select {
  .v-input__icon--append {
    margin-top: $space-1;

    .v-icon {
      color: var(--text-muted);
    }
  }

  .v-select__selections {
    margin-left: $space-1;

    input {
      // Placeholder will be empty when items are selected
    }
  }

  .v-select__slot {
    background-color: transparent;
  }

  .v-text-field--outlined input {
    padding: 0;
  }
}
</style>
